import { api } from "./api";

const store = {};
export const prefetch = (key, url) => { store[key] = api.get(url); store[key].catch(() => {}); };
export const take = (key, url) => { const p = store[key] ? store[key].catch(() => api.get(url)) : api.get(url); delete store[key]; return p; };
